<template>
  <svg :width="width" :height="height" viewBox="0 0 26 29" :fill="color" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0.954757V5.89661C0 6.23683 0.182576 6.55203 0.478887 6.72184L12.578 13.6746C13.2161 14.0417 13.2161 14.9587 12.578 15.3257L0.478887 22.2785C0.182576 22.4489 0 22.7635 0 23.1037V28.0456C0 28.7791 0.797945 29.2378 1.43606 28.8708L25.0063 15.3257C25.6444 14.9587 25.6444 14.0417 25.0063 13.6746L1.43606 0.12893C0.797945 -0.237508 0 0.220689 0 0.954757Z" fill="#80B7FF"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 14 },
    color: { type: String, default: colors.iconColor }
  },
  name: "IconSendMessage"
}
</script>

<style scoped>

</style>